import { useEffect, useRef, useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { downloadUrl } from "@/lib/download";
import { toast } from "sonner";
import { Presentation, FileUp, Download, Trash2, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export function PptxBox({ s, club, canUpload, onChanged }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [dl, setDl] = useState(false);
  const generating = s.audio_status === "generating";

  const download = async () => {
    setDl(true);
    try { await downloadUrl(`${API}${s.pptx_url}`, `Sessao-${s.session_number}.pptx`); }
    catch (err) { toast.error(err.message || "Não foi possível descarregar a apresentação"); }
    setDl(false);
  };

  useEffect(() => {
    if (!generating) return undefined;
    const t = setInterval(onChanged, 15000);
    return () => clearInterval(t);
  }, [generating, onChanged]);

  if (!canUpload && !s.pptx_url) return null;

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post(`/training/${club}/${s.session_number}/pptx`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      toast.success(r.data.audio_generating ? "Apresentação carregada — a gerar o áudio (pode levar alguns minutos)" : "Apresentação carregada");
      onChanged();
    } catch (err) { toast.error(formatApiError(err)); }
    setBusy(false);
  };
  const remove = async () => {
    if (!window.confirm("Remover a apresentação desta sessão?")) return;
    try { await api.delete(`/training/${club}/${s.session_number}/pptx`); onChanged(); }
    catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid={`training-pptx-box-${s.session_number}`}>
      <Presentation className="w-4 h-4 text-[#E50000]" />
      {s.pptx_url ? (
        <>
          <button onClick={download} disabled={dl}
            className="kw-btn-secondary !py-1 !px-3 text-xs inline-flex items-center gap-1"
            data-testid={`training-pptx-${s.session_number}`}>
            {dl ? <Loader2 className="w-3 h-3 animate-spin" /> : <Download className="w-3 h-3" />} PowerPoint
          </button>
          {canUpload && (
            <button onClick={remove} className="text-[#FF6B6B]" title="Remover apresentação" data-testid={`training-pptx-remove-${s.session_number}`}>
              <Trash2 className="w-3 h-3" />
            </button>
          )}
        </>
      ) : (
        <>
          <input ref={ref} type="file" accept=".pptx,.ppsx" className="hidden" onChange={(e) => upload(e.target.files?.[0])}
            data-testid={`training-pptx-input-${s.session_number}`} />
          <button onClick={() => ref.current?.click()} disabled={busy}
            className="kw-btn-secondary !py-1 !px-3 text-xs inline-flex items-center gap-1" data-testid={`training-pptx-upload-${s.session_number}`}>
            {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <FileUp className="w-3 h-3" />} Carregar PowerPoint
          </button>
        </>
      )}
      {generating && <span className="text-[10px] uppercase tracking-widest text-[#EAB308] inline-flex items-center gap-1"><Loader2 className="w-3 h-3 animate-spin" /> A gerar áudio…</span>}
      {s.audio_status === "error" && <span className="text-[10px] text-[#FF6B6B]">{s.audio_error}</span>}
      {canUpload && <span className="text-[10px] text-[#555] w-full">Só o Secretário e o Capitão recebem a apresentação (com o QR, 24h e 2h antes).</span>}
    </div>
  );
}
